import Link from '@eduzz/houston-ui/Link';
import Alert from '@material-ui/lab/Alert';
import * as React from 'react';
import Modal from 'v2/components/Shared/Modal';

type NewAccountWarningModalProps = {
  isOpen: boolean;
  setClose: () => void;
};
function NewAccountWarningModal({ isOpen, setClose }: NewAccountWarningModalProps) {
  return (
    <Modal
      open={isOpen}
      textTitle='Nova conta bancária'
      textProceedButton='OK'
      setClose={setClose}
      handleProceedClick={setClose}
      textReturnButton=''
      hideReturnButton
    >
      <Alert severity='warning'>
        Para cadastrar uma conta bancária é necessário ter pelo menos R$ 100,01 de saldo disponível.
        <br />
        Para mais informações,{' '}
        <Link
          href='https://ajuda.eduzz.com/hc/pt-br/articles/1260807398070-Como-cadastrar-dados-banc%C3%A1rios-%C3%93rbita-'
          target='_blank'
          rel='noopener noreferrer'
        >
          clique aqui
        </Link>
        .
      </Alert>
    </Modal>
  );
}

export { NewAccountWarningModal };
